








import { Vue, Component } from "@/shared/vuepack";
import MyProgramMetrics from "@/employer/components/myprogram/MyProgramMetrics.vue";
import MyPlans from "@/employer/components/myprogram/MyPlans.vue";
import MyProgramNavigation from "@/employer/components/myprogram/MyProgramNavigation.vue";

@Component({
  components: {
    MyProgramNavigation,
    MyProgramMetrics,
    MyPlans,
  }
})
export default class MyProgramHealth extends Vue {
}
